import {
  distance,
  getRandomNormal,
  vectorFromTo,
  vectorNormalize,
  vectorAvg,
} from "./MathHelper";

// FIXME remove hardcoded constants, refactor out pure "game" functions
// refactor functions to be pure, tightly manage effects

//TODO remove these hardcoded constants
const MAX_X = 1366;
const MAX_Y = 768;

const locationAggroRange = (loc, entity) => {
  // TODO fuck with this
  return loc.heat * 40 + 50.0;
};

const transferAggroRange = (transfer, entity) => {
  // TODO change this heuristic, where larger transfers will have a wider
  // detection radius
  return 100 + entity.seekRadius;
};

const randomRaidType = (inactiveLocations) => {
  // linear increase to raid success chance as sites are lost
  const raidBonus = Math.sqrt(inactiveLocations) * 0.05;
  const raidRoll = Math.random() + raidBonus;
  if (raidRoll >= 0.98) {
    return raidTypes.full;
  } else if (raidRoll >= 0.84) {
    return raidTypes.big;
  } else if (raidRoll >= 0.69) {
    return raidTypes.moderate;
  } else if (raidRoll >= 0.45) {
    return raidTypes.small;
  } else {
    return null;
  }
};

const raidTypes = {
  full: {
    moneyMod: 1.0,
    heatMod: 1.0,
    kill: true,
    msg: "Agents have shut down our operation in ",
  },
  big: {
    moneyMod: 0.7,
    heatMod: 0.9,
    kill: false,
    msg: "Agents have carried out a big raid in ",
  },
  moderate: {
    moneyMod: 0.4,
    heatMod: 0.8,
    kill: false,
    msg: "Agents have carried out a raid in ",
  },
  small: {
    moneyMod: 0.1,
    heatMod: 0.7,
    kill: false,
    msg: "Agents have carried out a small raid in ",
  },
};

export const updateEntities = (state, entities) => {
  return entities
    .map((entity) => {
      return updatePosition(entity);
    })
    .map((entity) => {
      return handleTrackBehavior(state, entity);
    })
    .map((entity) => {
      return checkEdge(entity);
    })
    .map((entity) => {
      if (offTheGrid(entity)) {
        entity.dead = true;
      }
      return entity;
    })
    .filter((entity) => {
      return !entity.dead;
    });
};

export const updatePosition = (entity) => {
  // update positions in accordance with speed and velocity
  const newPosition = {
    x: entity.position.x + entity.velocity.x * entity.speed,
    y: entity.position.y + entity.velocity.y * entity.speed,
  };
  return { ...entity, position: newPosition };
};

export const offTheGrid = (pos) => {
  if (pos.x < -10) {
    return true;
  }
  if (pos.y < -10) {
    return true;
  }
  if (pos.x > MAX_X + 10) {
    return true;
  }
  if (pos.y > MAX_Y + 10) {
    return true;
  }
  return false;
};

function getEdge(pos, dim) {
  if (pos.x < 0) {
    return "left";
  }
  if (pos.y < 0) {
    return "top";
  }
  const rightEdge = pos.x + dim;
  const bottomEdge = pos.y + dim;

  if (bottomEdge > MAX_Y) {
    return "bottom";
  }
  if (rightEdge > MAX_X) {
    return "right";
  }
  return null;
}

export const checkEdge = (entity) => {
  const edgeDie = () => {
    // check only if dead flag hasn't been set already
    if (!entity.dead) {
      const edge = getEdge(entity.position, entity.dimension);
      entity.dead = edge !== null;
    }
  };

  const edgeBounce = () => {
    const e = getEdge(entity.position, entity.dimension);
    const v = entity.velocity;
    const p = entity.position;
    switch (e) {
      case "bottom":
        p.y -= 5;
        v.y = -v.y;
        break;
      case "top":
        p.y += 5;
        v.y = -v.y;
        break;
      case "left":
        p.x += 5;
        v.x = -v.x;
        break;
      case "right":
        p.x -= 5;
        v.x = -v.x;
        break;
      default:
        break;
    }
    entity.velocity = v;
    entity.position = p;
  };

  switch (entity.edgeBehavior) {
    case "die":
      edgeDie();
      break;
    case "bounce":
      edgeBounce();
      break;
    default:
      break;
  }
  return entity;
};

const curveTowards = (entity, tgtPos) => {
  const v1 = entity.velocity;
  const v2 = vectorNormalize(vectorFromTo(entity.position, tgtPos));
  const v3 = vectorAvg(v1, v1, v2);
  entity.velocity = v3;
};

const transferEntities = (state) => {
  const transfers = state.entities.filter((entity) => {
    return entity.face === "transfer";
  });
  return transfers;
};

export const handleTrackBehavior = (state, entity) => {
  if (!entity.dead) {
    if (entity.trackBehavior === "seekanddestroy") {
      return handleSeekAndDestroy(state, entity);
    } else if (entity.face === "transfer") {
      return handleTransfer(state, entity);
    } else {
      return entity;
    }
  } else {
    return entity;
  }
};

const handleTransfer = (state, entity) => {
  // transfer/city logic
  const tgtId = entity.transferTarget;
  const tgtPos = state.locations[tgtId].position;
  const d = distance(tgtPos, entity.position);
  if (d < entity.transferRadius) {
    entity.dead = true;
    state.addLocationMoney(tgtId, entity.money);
    // state.locations[tgtId].money += entity.money;
    // state.locations = [...state.locations];
    state.sendMessage(
      "Transferred $" +
        entity.money.toLocaleString() +
        " to " +
        state.locations[tgtId].name
    );
  }
  return entity;
};

const handleSeekAndDestroy = (state, entity) => {
  const findTransferById = (id) => {
    let res = null;
    for (const t of state.entities) {
      if (t.face === "transfer") {
        if (t.id === id) {
          res = t;
          break;
        }
      }
    }
    return res;
  };

  const findTargetTransfer = () => {
    const transfers = transferEntities(state);
    let foundTransfer = null;
    let foundTransferMoney = Number.MIN_SAFE_INTEGER;
    transfers
      .filter((transfer) => {
        const d = distance(entity.position, transfer.position);
        const r = transferAggroRange(transfer, entity);
        return d < r;
      })
      .forEach((transfer) => {
        if (transfer.money > foundTransferMoney) {
          foundTransfer = transfer;
          foundTransferMoney = transfer.money;
        }
      });
    return foundTransfer;
  };

  const findTargetLocation = () => {
    // logic for an agent to find an appealing location to creep on

    let resLoc = null;
    let maxHeat = Number.MIN_SAFE_INTEGER;
    state.locations
      .filter((loc) => {
        if (!loc.active) {
          return false;
        }
        const r = locationAggroRange(loc, entity);
        const d = distance(loc.position, entity.position);
        return d < r;
      })
      .forEach((loc) => {
        if (loc.heat > maxHeat) {
          resLoc = loc.id;
          maxHeat = loc.heat;
        }
      });
    return resLoc;
  };

  const becomeIdle = () => {
    const trackingState = { state: "idle", sleep: true };
    setTimeout(() => {
      trackingState.sleep = false;
    }, entity.trackingSleep);
    entity.trackingState = trackingState;
    entity.velocity = getRandomNormal();
  };

  const killTransfer = (transfer) => {
    if (!transfer.dead) {
      state.markTransferDead(transfer.id);
      state.sendMessage(
        "Agents intercepted a $" +
          transfer.money.toLocaleString() +
          " transfer!",
        3,
        "bad"
      );
    }
  };

  const assignNewTrackingState = () => {
    let trackingState = null;
    {
      const foundTransfer = findTargetTransfer();
      if (foundTransfer !== null) {
        // target aquired
        trackingState = {
          state: "transfer",
          transferId: foundTransfer.id,
        };
      }
    }
    if (trackingState === null) {
      const hl = findTargetLocation();
      if (hl !== null) {
        // target aquired
        trackingState = { state: "location", location: hl };
      }
    }
    if (trackingState !== null) {
      entity.trackingState = trackingState;
    }
  };

  // tracking logic for agents
  // no, I don't know what's going on here either
  switch (entity.trackingState.state) {
    case "idle": {
      if (!entity.trackingState.sleep) {
        // find a new tracking state
        assignNewTrackingState();
      }
      break;
    }
    case "location": {
      // continue heading towards location, if we're near location, trigger a raid
      const tgtLocId = entity.trackingState.location;
      const tgtPos = state.locations[tgtLocId].position;
      const d = distance(tgtPos, entity.position);
      if (d < entity.raidRadius) {
        // carry out a raid, then idle
        const r = randomRaidType(state.inactiveLocations);
        if (r !== null) {
          state.raidLocation(tgtLocId, r, entity.raidMod);
        } else {
          //console.log("doing nothing");
        }
        becomeIdle();
      } else {
        const foundTransfer = findTargetTransfer();
        if (foundTransfer !== null) {
          entity.trackingState = {
            state: "transfer",
            transferId: foundTransfer.id,
          };
        } else {
          if (state.locations[tgtLocId].active) {
            curveTowards(entity, tgtPos);
          } else {
            becomeIdle();
          }
        }
      }
      break;
    }
    case "transfer": {
      const tgtId = entity.trackingState.transferId;
      const tgt = findTransferById(tgtId);
      if (tgt !== null) {
        const tgtPos = tgt.position;
        const d = distance(tgtPos, entity.position);
        if (d < entity.destroyRadius) {
          killTransfer(tgt);
        } else {
          curveTowards(entity, tgtPos);
        }
      } else {
        // if transfer is already dead, switch to idle
        becomeIdle();
      }
      break;
    }
    default:
      // invalid state
      break;
  }
  return entity;
};
